import React, {FC} from 'react';
import styled from 'styled-components';

import {buildInteractionIdProps} from '../../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  computeIsGlobalNamespace,
  isTeamNamespace,
} from '../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {AnalyticsPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {AnalyticsReportsEnum} from '../../helpers/reportHelpers/reportTypes';
import {StyledAnalyticsNavigationTitleDiv} from './legacyReportNavigationLinks';
import {ReportNavigationLink} from './reportNavigationLink';

/*
 * Constants.
 */

const interactionId = 'analytics-external-reports';

/*
 * Props.
 */

interface ReportNavigationExternalReportsProps {
  panelId: AnalyticsPanelId;
  namespace: string;
  isDisabled: boolean;
}

/*
 * Style.
 */

const StyledNavigationHelpWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 20px;

  &:first-child {
    margin-top: 4px;
  }
`;

/*
 * Component.
 */

export const ReportNavigationExternalReports: FC<ReportNavigationExternalReportsProps> = ({
  panelId,
  namespace,
  isDisabled,
}) => {
  const isValidNamespace = isTeamNamespace(namespace) || computeIsGlobalNamespace(namespace);
  const isSupportReportVisible = isValidNamespace;

  if (!isSupportReportVisible) {
    return null;
  }
  return (
    <StyledNavigationHelpWrapperDiv {...buildInteractionIdProps(interactionId)}>
      <StyledAnalyticsNavigationTitleDiv>
        <Trans id="analytics-external-reports-navigation-title">External</Trans>
      </StyledAnalyticsNavigationTitleDiv>
      <ReportNavigationLink
        panelId={panelId}
        reportType={AnalyticsReportsEnum.SUPPORT_REPORT}
        iconName="articleSmall"
        selectedIconName="articleFilledSmall"
        isDisabled={isDisabled}
      >
        <Trans id="analytics-support-report-navigation-item">Support Report</Trans>
      </ReportNavigationLink>
    </StyledNavigationHelpWrapperDiv>
  );
};
